import { siteConfig } from '@/configs/siteConfig';

import { siteStateStore } from '@/stores/siteStateStore';

const props = {} as const;

const state = {};

const siteStateGetter = {
  // DOM（キャッシュ）
  get headerEl(): HTMLElement | null {
    if (!siteStateStore.dom.headerEl) {
      siteStateStore.dom.headerEl = document.getElementById(siteConfig.id.header);
    }
    return siteStateStore.dom.headerEl;
  },
  get headerHeight(): number {
    return this.headerEl?.offsetHeight ?? 0;
  },

  get footerEl(): HTMLElement | null {
    if (!siteStateStore.dom.footerEl) {
      siteStateStore.dom.footerEl = document.getElementById(siteConfig.id.footer);
    }
    return siteStateStore.dom.footerEl;
  },
  // get footerTopY(): number {
  //   const footer = this.footerEl;
  //   if (!footer) return 0;

  //   return footer.getBoundingClientRect().top + siteStateStore.viewport.scrollY;
  // },

  get splashEl(): HTMLElement | null {
    if (!siteStateStore.dom.splashEl) {
      siteStateStore.dom.splashEl = document.getElementById(siteConfig.id.splash);
    }
    return siteStateStore.dom.splashEl;
  },

  // ビューポート情報（キャッシュ）
  get winWidth() {
    return siteStateStore.viewport.winWidth;
  },

  get winHeight() {
    return siteStateStore.viewport.winHeight;
  },

  get docWidth() {
    return siteStateStore.viewport.docWidth;
  },

  get docHeight() {
    return siteStateStore.viewport.docHeight;
  },

  get scrollY() {
    return siteStateStore.viewport.scrollY;
  },

  get scrollDir() {
    return siteStateStore.viewport.scrollDir;
  },

  // マウスカーソル情報（キャッシュ）
  get mousePos() {
    return { x: siteStateStore.mouse.x, y: siteStateStore.mouse.y };
  },
  get mousePrev() {
    return siteStateStore.mouse.prev;
  },
  get mouseNormalized() {
    return siteStateStore.mouse.normalized;
  },
  get mouseRaw() {
    return siteStateStore.mouse; // 必要なら丸ごと
  },

  // その他静的情報
  get url() {
    return new URL(window.location.href);
  },

  get referrer() {
    return document.referrer ? new URL(document.referrer) : null;
  },

  get isHover() {
    return window.matchMedia('(hover: hover)').matches;
  },

  get isTouch() {
    return window.matchMedia('(pointer: coarse)').matches;
  },

  get dataPage() {
    return document.body?.dataset.page?.trim() || null;
  },
};

export { siteStateGetter as siteState };
